import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import { type BinaryResponse, writeBase64Output } from '../files.js';
import type { CommandResult } from '../output.js';
import { withClient } from './common.js';

export async function screenshotCommand(args: ParsedArgs): Promise<CommandResult> {
  const output = flag(args.flags, 'output');
  if (!output) throw new CliError('screenshot requires --output <path>', ExitCode.Usage);
  const response = await withClient(args.options, (client) =>
    client.request<BinaryResponse>(Methods.Screenshot),
  );
  return { data: writeBase64Output(response, output) };
}
